module.exports = __webpack_public_path__ + "img/sign-warning.acc48eaa.svg";